import classNames from 'classnames';
import { selectOverlay } from 'ducks/overlays/selectors';
import { selectSettings } from 'ducks/settings/selectors';
import { useAppSelector } from 'store/hooks';

import { Drawer } from 'components/drawer/Drawer';
import { Helmet } from 'components/helmet/Helmet';

import { DRAWER_CLOSED, DRAWER_OPEN } from '../../constants';

import { PageProps } from './types';

import cn from './Page.module.scss';

export const Page = ({ title, direction = 'column', description, children }: PageProps) => {
  const { offset_navigation } = useAppSelector(selectSettings);
  const { is_open } = useAppSelector(selectOverlay('drawer'));
  const width = is_open ? DRAWER_OPEN : DRAWER_CLOSED;
  return (
    <>
      <Helmet title={title} description={description} />
      <div className={cn.page} style={{ marginTop: offset_navigation }}>
        <Drawer />
        <div
          className={classNames(cn.section, 'transition')}
          style={{ marginLeft: width, flexDirection: direction }}
        >
          {children}
        </div>
      </div>
    </>
  );
};
